import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import {
  siteBoxDocumentsKeys,
  RequestTypes,
} from '@core/react-query/features/siteBoxDocuments'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import { foldersKeys } from '../../folders'

export const useUpdateSiteBoxDocument = (
  options?: UseMutationOptions<
    unknown,
    RequestErrorType,
    RequestTypes['updateDocument']
  >,
) => {
  const queryClient = useQueryClient()
  return useMutation({
    ...siteBoxDocumentsKeys.updateDocument,
    onSuccess: (_, { documentId }) => {
      queryClient.invalidateQueries({
        queryKey: siteBoxDocumentsKeys.byId({ documentId }).queryKey,
      })
      queryClient.invalidateQueries({
        queryKey: foldersKeys._def,
      })
    },
    ...options,
  })
}
